import React, { useEffect, useState } from "react";
import '../../pages/viewUser/viewUser.css'
import { FaPause, FaPlay } from "react-icons/fa6";
import { useParams } from "react-router-dom";

const ViewInstruction = () => {

    const [startAudio, setStartAudio] = useState(false)
    const [viewInstruction, setViewInstruction] = useState({})
    const params = useParams()

    const getInstruction = async () => {

        try {
            if (params.id) {
                const response = null;
                if (response) {
                    setViewInstruction(response)
                }
            }
        } catch (error) {

        }

    }

    useEffect(() => {
        getInstruction()
    }, [])

    return (
        <div className="container mb-5">
            <div className="overview d-flex align-items-center justify-content-between">
                <div className="title">
                    <ion-icon name="eye-outline"></ion-icon>
                    <span className="text">View Instruction</span>
                </div>
            </div>

            <div className="mt-4">
                <div className="userInfo mt-4">
                    <label>Instruction number</label>
                    <div>{viewInstruction.instructionNumber}</div>
                </div>
                <div className="userInfo mt-4">
                    <label>Title</label>
                    <div>{viewInstruction.title}</div>
                </div>
                <div className="userInfo mt-4">
                    <label>Location</label>
                    <div>
                        {viewInstruction.location?.map((item) => (
                            ` ${item} ,`
                        ))}
                    </div>
                </div>
                <div className="userInfo mt-4">
                    <label>Media</label>
                    <div className='d-flex justify-content-lg-start mt-2'>
                        <div className='recordingMicIcon'>
                            {startAudio ? (
                                <FaPause onClick={() => { setStartAudio(false) }} className='pauseIconFont' />
                            ) : (
                                <FaPlay onClick={() => { setStartAudio(true) }} className='playIconFont' />
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ViewInstruction;
